import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  IconButton,
  Typography,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import LandscapeIcon from "@mui/icons-material/Landscape";
//import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

export default function CreateTag(props) {
  const searchParams = new URLSearchParams(window.location.search);
  const productId = searchParams.get("product_id");
  const [tagsData, setTagsData] = useState([]);
  const [familyData, setFamilyData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(true);
  const [productTag, setProductTag] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [status, setStatus] = useState("");
  //const [newCategory, setNewCategory] = useState("");
  const [isCreatingCategory, setIsCreatingCategory] = useState(false);
  //const [newFamily, setNewFamily] = useState("");
  const [isCreatingFamily, setIsCreatingFamily] = useState(false);
  const [tagImage, setTagImage] = useState("");

  const handleTagSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const reqData = {
      'id': productId ? productId : "",
      'product_tag': productTag ? productTag : "",
      'tag_family': selectedFamily ? selectedFamily : "",
      'category': selectedCategory ? selectedCategory : "",
      'created_by': createdBy ? createdBy : "",
      'updated_by': updatedBy ? updatedBy : "",
      'image_url': imageUrl ? imageUrl : [],
      'status': status ? status : 1,
    };

    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    if (tagImage) {
      reqData.image_url = await convertToBase64(tagImage);
    } else {
      reqData.image_url = imageUrl; // Use the object URL if no file is uploaded
    }

    try {
      const resData = await postData("/api/product/acc_tag_master", reqData);
      if (resData["data"]["code"] === "200") {
        setLoading(false);
        alert("Tag created successfully");
        setTagImage(null);
        setImageUrl(null);
        setProductTag("");
        setSelectedFamily("");
        setSelectedCategory("");
        setCreatedBy("");
        setUpdatedBy("");
        setStatus("");
        // Call parent callback to update table
        if (props.onTagCreated) {
          // Compose the new tag object as returned by the API, fallback to reqData
          const newTag = resData.data.tag || reqData;
          props.onTagCreated(newTag);
        }
        // Do not reload or redirect
      } else {
        alert("Tag creation failed");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      alert("Error submitting form");
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        let familyRes = await getData("/api/product/acc_tag_family");
        console.log(familyRes);
        let family_data = familyRes["data"]["tag_families"];
        if (family_data) {
          console.log(family_data);
          setFamilyData(family_data);
        } else {
          console.error("Error fetching tags family data:", familyRes.message);
        }

        let categoryRes = await getData("/api/product/acc_tag_category");
        console.log(categoryRes);
        let category_data = categoryRes["data"]["tag_categories"];
        if (category_data) {
          console.log(category_data);
          setCategoryData(category_data);
        } else {
          console.error("Error fetching tags category data:", categoryRes.message);
        }

        let masterRes = await getData("/api/product/acc_tag_master");
        console.log(masterRes);
        let master_data = masterRes["data"]["tag_masters"];
        if (master_data) {
          console.log(master_data);
          setTagsData(master_data);
        } else {
          console.error("Error fetching tag master data:", masterRes.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const img = new Image();
      const imageUrl = URL.createObjectURL(file);
      img.src = imageUrl;
      img.onload = () => {
        if (img.width === 120 && img.height === 60) {
          setImageUrl(imageUrl); // Set the image URL for preview
          setTagImage(file);
          console.log("Tag image uploaded successfully:", file);
        } else {
          alert("Image must be exactly 120px wide and 60px tall.");
          URL.revokeObjectURL(imageUrl); // Free up memory
        }
      };
      img.onerror = () => {
        alert("Failed to load image. Please try again.");
        URL.revokeObjectURL(imageUrl); // Free up memory
      };
    }
  };

  /* const handleCreateNewCategory = () => {
    setIsCreatingCategory(true);
    setNewCategory("");
  };

  const handleCreateNewFamily = () => {
    setIsCreatingFamily(true);
    setNewFamily("");
  };

  const handleCategorySubmit = (e) => {
    if (e.key === "Enter" && newCategory.trim() !== "") {
      const newCategoryObj = {
        id: categoryData.length + 1, // Simple ID assignment
        category: newCategory.trim(),
      };

      setCategoryData([...categoryData, newCategoryObj]); // Add new category to list
      setSelectedCategory(newCategoryObj.id); // Select the new category
      setIsCreatingCategory(false); // Close input field
    } else if (e.key === "Escape") {
      setIsCreatingCategory(false); // Cancel category creation on Escape key
    }
  };

  const handleFamilySubmit = (e) => {
    if ((e.type === "keydown" && e.key === "Enter") || e.type === "click") {
      if (newFamily.trim() !== "") {
        const newFamilyObj = {
          id: familyData.length + 1,
          tag_family: newFamily.trim(),
        };

        setFamilyData([...familyData, newFamilyObj]); // Add new family
        setSelectedFamily(newFamilyObj.id); // Select new family
        setIsCreatingFamily(false); // Hide input field
        setNewFamily(""); // Reset input
      }
    }
  }; */

  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <Grid container sx={{ flex: 1, height: "100%" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          {/* Create A New Tag Section */}
          <Box
            sx={{
              mt: 3,
              mb: 6,
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontFamily: "Inter", fontWeight: "700", fontSize: 15 }}
            >
              Create A New Tag
            </Typography>

            <Grid container spacing={2} sx={{ mt: 1 }}>
              {/* Product Tag */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Product Tag
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "35px",
                      borderRadius: "0px",
                    },
                  }}
                  value={productTag}
                  onChange={(e) => setProductTag(e.target.value)}
                />
              </Grid>

              {/* Tag Category */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Tag Category
                </Typography>
                {isCreatingCategory ? (
                  {
                    /* <TextField
                      fullWidth
                      size="small"
                      sx={{
                        fontSize: 14,
                        "& .MuiOutlinedInput-root": {
                          height: "35px",
                          borderRadius: "0px",
                        },
                      }}
                      value={newCategory}
                      onChange={(e) => setNewCategory(e.target.value)}
                      onKeyDown={handleCategorySubmit}
                      autoFocus
                      placeholder="Enter new category"
                    /> */
                  }
                ) : (
                  <Select
                    fullWidth
                    size="small"
                    sx={{ height: "35px", borderRadius: "0px" }}
                    value={selectedCategory}
                    onChange={(event) =>
                      setSelectedCategory(event.target.value)
                    }
                  >
                    {/* <MenuItem
                        onClick={handleCreateNewCategory}
                        value=""
                        sx={{ border: "1px solid #bcc1ca", fontSize: 14 }}
                      >
                        <AddCircleOutlineIcon sx={{ fontSize: 15, mr: 1 }} />
                        Create a new Category
                      </MenuItem> */}
                    {categoryData.map((category) => (
                      <MenuItem
                        key={category.id}
                        value={category.id}
                        sx={{ fontSize: 14 }}
                      >
                        {category.category}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </Grid>

              {/* Tag Family */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#424956",
                    fontFamily: "Inter",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  Tag Family
                </Typography>
                {isCreatingFamily ? (
                  {
                    /* <TextField
                      fullWidth
                      size="small"
                      sx={{
                        fontSize: 14,
                        "& .MuiOutlinedInput-root": {
                          height: "35px",
                          borderRadius: "0px",
                        },
                      }}
                      value={newFamily}
                      onChange={(e) => setNewFamily(e.target.value)}
                      onKeyDown={handleFamilySubmit}
                      autoFocus
                      placeholder="Enter new family"
                    /> */
                  }
                ) : (
                  <Select
                    fullWidth
                    size="small"
                    sx={{ height: "35px", borderRadius: "0px" }}
                    value={selectedFamily}
                    onChange={(event) => setSelectedFamily(event.target.value)}
                  >
                    {/* <MenuItem
                        onClick={handleCreateNewFamily}
                        value=""
                        sx={{ border: "1px solid #bcc1ca", fontSize: 14 }}
                      >
                        <AddCircleOutlineIcon sx={{ fontSize: 15, mr: 1 }} />
                        Create a new Family
                      </MenuItem> */}
                    {familyData.map((family) => (
                      <MenuItem
                        key={family.id}
                        value={family.id}
                        sx={{ fontSize: 14 }}
                      >
                        {family.tag_family}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </Grid>

              {/* Upload Section */}
              <Grid item xs={12} sm={6} md={3}>
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="upload-button"
                  onChange={handleImageUpload}
                />
                <Box
                  sx={{
                    mt: 0.5,
                    width: 120,
                    height: 60,
                    border: "1px solid #FAFAFB",
                    backgroundColor: "#FAFAFB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="Uploaded"
                      style={{ width: "100%", height: "100%" }}
                    />
                  ) : (
                    <LandscapeIcon sx={{ color: "#BCC1CA" }} />
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 1,
                    width: 120,
                  }}
                >
                  <label style={{ fontSize: "13px", color: "black" }}>
                    Upload Image (120x60px)
                  </label>
                  <IconButton
                    component="label"
                    size="small"
                    sx={{ color: "#000" }}
                  >
                    <FileUploadOutlinedIcon />
                    <input
                      type="file" 
                      accept="image/*"
                      hidden
                      onChange={handleImageUpload}
                    />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>

            <Box>
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: "#565E6D",
                  border: "1px solid #565E6D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#546e7a" },
                  borderRadius: "0px",
                }}
                onClick={handleTagSubmit}
              >
                Save new tag
              </Button>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Box>
  );
}
